module.exports = __webpack_public_path__ + "static/media/NUS_Wheel.de9335bd.png";